export enum BonusesAction {
  ADD_BONUSES = "addBonuses",
  ADD_AVAILABLE_BONUSES = "addAvailableBonuses",
  ADD_MY_ACTIVATED_BONUSES = "addMyActivatedBonuses",
  FETCH_BONUSES = "getBonuses",
  FETCH_MY_ACTIVATED_BONUSES = "fetchMyActivatedBonuses",
  FETCH_AVAILABLE_BONUSES = "fetchAvailableBonuses",
  FETCH_BONUSES_IMAGES = "fetchBonusesImages",
  FETCH_MY_ACTIVATED_BONUSES_IMAGES = "fetchMyActivatedBonusesImages",
  ACTIVATE_GLOBAL_BONUS = "activateGlobalBunus",
  FETCH_BONUS_BY_ID = "fetchBonusById",
  CANCEL_BONUS = "cancelBonus",
}
